/**************************************************
 * Nombre:       Detalle_Sobre_Servicio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {COLORTEXTO, SERVICIOS} from "../../../Constantes";
import {ArrowForward} from '@mui/icons-material'


const Detalle_Sobre_Servicio = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={8}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 4}}
                            sx={{
                                backgroundColor: theme.palette.secondary.main,
                                borderRadius: 6,
                                px: 4,
                                py: 6,
                                color: COLORTEXTO
                            }}
                            spacing={0}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Typography sx={{fontSize: 20, fontWeight: 800}}>Mas Servicios</Typography>
                            </Grid>

                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 3}}
                            >

                                {SERVICIOS.map((it, index) => {
                                    return (
                                        <Grid
                                            container
                                            justifyContent={'flex-start'}
                                            alignItems={'center'}
                                            size={{xs: 12, sm: 12, md: 12}}>

                                            <Grid container size={{xs: 12, sm: 12, md: 10}}
                                                  sx={{justifyContent: 'flex-start', mt: 3}}>
                                                <Typography sx={{fontSize: 18, fontWeight: 500}}>{it}</Typography>
                                            </Grid>

                                            <Grid container size={{xs: 12, sm: 12, md: 2}}
                                                  sx={{justifyContent: 'flex-end'}}>
                                                <ArrowForward/>
                                            </Grid>

                                        </Grid>

                                    )
                                })}

                            </Grid>


                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 8}}
                        spacing={0}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: 42, fontWeight: 800, color: COLORTEXTO}}>Acerca de Terapia
                                    Individual</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                <Typography sx={{fontSize: 18, fontWeight: 400, color: COLORTEXTO}}>
                                    Lorem Ipsum es simplemente el texto de relleno de las imprentas y archivos de texto.
                                    Lorem Ipsum ha sido el texto de relleno estándar de las industrias desde el año
                                    1500, cuando un impresor (N. del T. persona que se dedica a la imprenta) desconocido
                                    usó una galería de textos y los mezcló de tal manera que logró hacer un libro de
                                    textos especimen. No sólo sobrevivió 500 años, sino que tambien ingresó como texto
                                    de relleno en documentos electrónicos, quedando esencialmente
                                </Typography>
                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Sobre_Servicio